module.exports = __webpack_public_path__ + "static/img/half_pitch_black.7197643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half_pitch_black.png
// module id = NtN7
// module chunks = 94